import { useState } from "react";

export interface FilterPreset<T> {
  id: string;
  name: string;
  filters: T;
  createdAt: string;
}

export function useFilterPresets<T>(storageKey: string) {
  const [presets, setPresets] = useState<FilterPreset<T>[]>(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      return raw ? (JSON.parse(raw) as FilterPreset<T>[]) : [];
    } catch {
      return [];
    }
  });

  function persist(next: FilterPreset<T>[]) {
    setPresets(next);
    try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch {}
  }

  function save(name: string, filters: T) {
    const trimmed = name.trim();
    if (!trimmed) return;
    persist([
      ...presets,
      { id: crypto.randomUUID(), name: trimmed, filters, createdAt: new Date().toISOString() },
    ]);
  }

  function remove(id: string) {
    persist(presets.filter((p) => p.id !== id));
  }

  function rename(id: string, name: string) {
    const trimmed = name.trim();
    if (!trimmed) return;
    persist(presets.map((p) => (p.id === id ? { ...p, name: trimmed } : p)));
  }

  return { presets, save, remove, rename };
}

// Storage keys
export const PRESETS_KEY_PROJECTS = "centcom_presets_projects";
export const PRESETS_KEY_ACCOUNTS = "centcom_presets_accounts";
export const PRESETS_KEY_FEEDBACK = "centcom_presets_feedback";
